import React from 'react';
import { useLocation } from '@thd-olt-component-react/router';
import { useWindow } from './useWindow';

const getUrlSearchParams = (param, queryString) => {
  const searchParam = new RegExp('[?&]' + param + '=([^&#]*)').exec(queryString);
  return searchParam && decodeURI(searchParam[1]);
};

export const useShouldDisplayReferrerRecommendations = () => {
  const { search } = useLocation();
  const window = useWindow();

  const isFromSearchEngine = /google.com|bing.com|yahoo.com|duckduckgo.com|aol.com/i.test(window.document.referrer);
  const isFromProductListAd = /^Shopping/.test(getUrlSearchParams('cm_mmc', search));
  const isFromPinterest = /PIN_Shopping/.test(getUrlSearchParams('cm_mmc', search));

  return isFromSearchEngine || isFromProductListAd || isFromPinterest;
};
